// components/ResetButton.js
import React from "react";
import { FiRefreshCw } from "react-icons/fi";
import styles from './ResetButton.module.css';

export default function ResetButton({ onReset }) {
  return (
    <button
      className={styles.resetBtn}
      title="Resetar chat"
      onClick={onReset}
    >
      <FiRefreshCw />
    </button>
  );
}